<template style="height:100%">
  <div class="Test">
    <el-tabs v-model="activeName">
      <el-tab-pane label="功能权限管理" name="first">
          <Set_permissions/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Set_department from './Set_department'
import Set_permissions from './Set_permissions'
import Set_clean from './Set_clean'
// import Setdatabase from './Setdatabase'
    
  export default {
    data() {
      return {
        activeName: 'first'
      };
    },
    components:{
      Set_department,
      Set_permissions,
      Set_clean,
      // Setdatabase,
    },
    methods: {
      handleClick(tab, event) {
      }
    }
  };
</script>
<style>
.Test{min-height: 99%;position: relative;background-color: #fff;}
.Test .el-tabs__nav-scroll{border: 1px solid #e3e3e3;padding-left: 16px;}
.Test .el-tabs__header {margin: 0 0 0px;}
input{width: 300px;}
.Test .el-form--inline .el-form-item {width: 31.5%;}
.Test .el-form-item__content{width: 75%;}
.Test .el-select{width: 75%;}
.Test  .el-form-item__label{width: 70px;text-align: right;}
.Test .el-date-editor{width: 100%;}
.Test .cvde{width: 60%!important;}

.Nac{height: 170px;position: relative;border: 1px solid #e3e3e3;padding-top: 20px;padding: 16px;}
.Nac2{height: 300px;position: relative;border: 1px solid #e3e3e3;padding-top: 20px;padding: 16px;}

.change{width: 40px;margin-left: -80px;display: inline-block;height: 22px;margin-top: 22px;position: absolute;z-index: 10;cursor:pointer;color: #5e5a5a;}
.Test .cvbb{margin-bottom: 30px;}

.el-tooltip__popper{max-width:20%;}
.el-tooltip__popper,.el-tooltip__popper.is-dark{background:#f5f5f5 !important;
  color: #303133 !important;}
</style>